// This file contains utilities for intentional logging and error messaging
// targeted at developers using the framework.
import { isDevelopmentMode } from "../env";
/**
 * Throws an error with the specified message when the consumer is in development
 * mode.
 */ export function throwDevError(msg) {
    if (isDevelopmentMode()) {
        throw new Error(msg);
    }
}

//# sourceMappingURL=devLogger.js.map